import { useDirektvermarkters } from "../../../hooks/useDirektvermarkters";
import { useOperators } from "../../../hooks/useOperators";
import { OperatorFeatures } from "../../../urls";
import { useDirektvermarktungContract } from "./useDirektvermarktungContract";
import { useDirektvermarktungFormulaAllowedVariables } from "./useDirektvermarktungFormulaAllowedVariables";

export function useDirektvermarktungContractModalData(contractId?: string) {
  const editMode = !!contractId;

  const {
    data: direktvermarkter,
    isLoading: direktvermarkterLoading,
    error: direktvermarkterError
  } = useDirektvermarkters();

  const {
    data: direktvermarktungContract,
    isLoading: direktvermarktungContractLoading,
    error: direktvermarktungContractError
  } = useDirektvermarktungContract(contractId);

  const {
    data: formulaAllowedVariables,
    isLoading: formulaAllowedVariablesLoading,
    error: formulaAllowedVariablesError
  } = useDirektvermarktungFormulaAllowedVariables();

  const {
    data: formulaTemplates,
    isLoading: formulaTemplatesLoading,
    error: formulaTemplatesError
    // TODO in https://node-energy.atlassian.net/browse/WUP-8864: re-enable the actual hook/API after BE integrates it
  } = { data: undefined, isLoading: false, error: undefined };
  // } = useDirektvermarktungFormulaTemplates();

  const {
    data: operators,
    isLoading: operatorsLoading,
    error: operatorsError
  } = useOperators({
    activeFeatures: [
      OperatorFeatures.Paragraph6EEG,
      OperatorFeatures.RevenueMonitoring
    ]
  });

  const {
    data: revenueMonitoringOperators,
    isLoading: revenueMonitoringOperatorsLoading,
    error: revenueMonitoringOperatorsError
  } = useOperators({
    activeFeatures: [OperatorFeatures.RevenueMonitoring]
  });

  const {
    data: paragraph6Operators,
    isLoading: paragraph6OperatorsLoading,
    error: paragraph6OperatorsError
  } = useOperators({
    activeFeatures: [OperatorFeatures.Paragraph6EEG]
  });

  return {
    data: {
      direktvermarkter,
      direktvermarktungContract,
      formulaAllowedVariables,
      formulaTemplates,
      operators,
      revenueMonitoringOperators,
      paragraph6Operators
    },
    isLoading:
      (editMode && direktvermarktungContractLoading) ||
      operatorsLoading ||
      revenueMonitoringOperatorsLoading ||
      paragraph6OperatorsLoading ||
      direktvermarkterLoading ||
      formulaAllowedVariablesLoading ||
      formulaTemplatesLoading,
    error:
      (editMode && direktvermarktungContractError) ||
      operatorsError ||
      revenueMonitoringOperatorsError ||
      paragraph6OperatorsError ||
      direktvermarkterError ||
      formulaAllowedVariablesError ||
      formulaTemplatesError
  };
}
